import { toast } from "react-toastify";

export const logInvalidModel = (val: unknown, interfaceName: string): void => {
    if (process?.env?.logInterfaceWarnings) {
        // eslint-disable-next-line no-console
        console.warn(`Not a valid ${interfaceName}`, val);
        toast(`Invalid ${interfaceName} found. See console for details.`);
    }
};
